import { render } from "./ParallaxThree.vue?vue&type=template&id=0ca54083"
import script from "./ParallaxThree.vue?vue&type=script&lang=js"
export * from "./ParallaxThree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\a1bg493225\\Desktop\\logika\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__